import React from "react";

import { Flex } from "antd";

import { ExperimentResearchSection } from "../components/research/ExperimentResearchSection";
import { useExperimentEditor } from "../hooks/useExperimentEditor";

export const ExperimentResearchPage: React.FC = () => {
  const { experimentData, setExperimentData } = useExperimentEditor();

  return (
    <Flex vertical style={{ flex: 1 }}>
      <ExperimentResearchSection
        experimentData={experimentData}
        setExperimentData={setExperimentData}
      />
    </Flex>
  );
};

export default ExperimentResearchPage;
